import { Link } from "react-router-dom";
import { ArrowRight, BookOpen, CheckCircle2 } from "lucide-react";
import { AcademyLockup, Readout, StatusBadge } from "@/components/academy/AcademyBrand";
import { Artwork } from "@/components/academy/Artwork";
import { ACADEMY_TOPICS } from "@/lib/academy/content";
import { track } from "@/lib/academy/actions";
import { BTN_PRIMARY, BTN_SECONDARY, LABEL } from "@/lib/academy/ui";
import { ACADEMY_LAUNCHED } from "@/lib/academy/launch";
import { HomeTeaser } from "@/components/academy/teaser/HomeTeaser";

const LESSON_POINTS = ["What a data center is", "IT equipment vs. supporting infrastructure", "A quick sorting exercise and knowledge check"];

export default function AcademyFeature() {
  return ACADEMY_LAUNCHED ? <AcademyFeatureLive /> : <HomeTeaser />;
}

function AcademyFeatureLive() {
  return (
    <section id="academy" data-testid="home-academy-feature" aria-labelledby="home-academy-title" className="academy-feature academy-brand academy-field border-b hairline overflow-hidden scroll-mt-20">
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24 grid grid-cols-1 lg:grid-cols-12 gap-x-10 gap-y-12 items-center">
        <div className="lg:col-span-7 min-w-0">
          <AcademyLockup id="home-academy-brand" className="w-[min(70vw,280px)] sm:w-[360px]" />
          <Readout className="mt-10">Free lesson · systems · businesses · careers</Readout>
          <h2 id="home-academy-title" data-testid="home-academy-headline" className="mt-5 font-display text-[1.7rem] sm:text-4xl lg:text-[2.75rem] leading-[1.12] text-[#160907] text-balance">Learn the Industry Behind AI</h2>
          <p data-testid="home-academy-copy" className="mt-5 max-w-xl text-base sm:text-lg text-[#3D4049] leading-relaxed">Explore the systems, businesses, and careers powering digital infrastructure. Start with a free lesson or discover guided learning for yourself and your team.</p>
          <div className="mt-8 flex flex-col sm:flex-row sm:flex-wrap gap-3">
            <Link to="/academy" data-testid="home-academy-explore-btn" onClick={() => track("academy_cta_clicked", { cta: "home_explore" })} className={BTN_PRIMARY}>Explore Academy<ArrowRight size={14} aria-hidden="true" /></Link>
            <Link to="/academy#free-lesson" data-testid="home-academy-lesson-btn" onClick={() => track("academy_cta_clicked", { cta: "home_free_lesson" })} className={BTN_SECONDARY}><BookOpen size={14} aria-hidden="true" />Try a Free Lesson</Link>
          </div>
        </div>
        <div data-testid="home-academy-lesson-card" className="lg:col-span-5 academy-card overflow-hidden">
          <div className="relative h-[160px] border-b hairline bg-[#F7F8F9]">
            <Artwork direction="serverHall" className="absolute inset-0 w-full h-full" />
            <span className="absolute left-4 top-4"><StatusBadge status="sample" label="Free · Available Now" /></span>
          </div>
          <div className="p-6 md:p-7">
            <p className={LABEL}>Free lesson · no payment, no account</p>
            <p className="mt-2 font-display text-xl text-[#160907]">Inside a Data Center</p>
            <ul className="mt-4 space-y-2">{LESSON_POINTS.map((point) => <li key={point} className="flex gap-2 text-sm text-[#160907]"><CheckCircle2 size={15} aria-hidden="true" className="text-[#F6101A] shrink-0 mt-0.5" />{point}</li>)}</ul>
            <p className="mt-5 pt-4 border-t hairline font-mono-label text-[10px] text-[#3D4049]">{ACADEMY_TOPICS.join(" · ")}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
